// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2KBtV","options":"AnswerScale_options__1Os03","selected":"AnswerScale_selected__3VuoN"};